import { SelectOption } from 'src/types/common';
import { client } from 'src/utils/axios-client';
import { Box, Button, Chip, LinearProgress, Typography } from '@mui/material';
import Popover from '@mui/material/Popover';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import AccountImportStore from '../store/AccountImportStore';
import { Account } from '../../../../../stores/AccountStore';
import React from 'react';
import SimpleDialog from '../../../../../features/common/SimpleDialog';
import { DuplicateAccount } from '../../DuplicateAccountList/types/types';
import DuplicateAccountRow from '../../DuplicateAccountList/DuplicateAccountRow';

type Props = {
    account: Account;
};

const StatusColumn = ({ account }: Props) => {
    const [loading, setLoading] = React.useState(true);
    const [success, setSuccess] = React.useState(false);
    const [duplicateAccounts, setDuplicateAccounts] = React.useState([] as DuplicateAccount[]);
    const [dialogOpen, setDialogOpen] = React.useState(false);

    React.useEffect(() => {
        checkForDuplicates();
    }, [account]);

    const checkForDuplicates = async () => {
        const response = await client.post<DuplicateAccount[]>('/api/accounts/duplicates', {
            ...account,
        });

        if (response.data.length === 0) {
            setSuccess(true);
            setDuplicateAccounts([]);
        } else {
            setDuplicateAccounts(response.data);
        }

        setLoading(false);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setDialogOpen(true);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    {loading && <LinearProgress color="success" />}
                    {!loading && success && <Chip icon={<DoneIcon />} label="No" color="success" size="small" />}
                    {!loading && !success && (
                        <Chip
                            onClick={handleClick}
                            icon={<ErrorIcon />}
                            label={`Yes (${duplicateAccounts.length})`}
                            color="error"
                            size="small"
                        />
                    )}
                    {!loading && !success && duplicateAccounts.length > 0 && (
                        <SimpleDialog
                            open={dialogOpen}
                            onClose={() => setDialogOpen(false)}
                            size={'md'}
                            fullHeight={false}
                        >
                            <Box>
                                <Typography variant="h6">Possible Duplicate Accounts</Typography>
                            </Box>

                            {duplicateAccounts.map((acc) => (
                                <>
                                    <DuplicateAccountRow duplicate={acc} />
                                </>
                            ))}

                            {/*<DuplicateLeadTable leads={duplicateLeads} />*/}

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" size="small" onClick={() => setDialogOpen(false)}>
                                    Close
                                </Button>
                            </Box>
                        </SimpleDialog>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export { StatusColumn };
export default StatusColumn;
